import OwnershipLayer from './OwnershipLayer';
import { LAND_USE_COLOR_EXPRESSION } from '../core/land-use-definitions';
import { landUseAttribution } from './attribution';

export default class LandUseLayer extends OwnershipLayer {
    static ID = 'landUse';
    static DESCRIPTION = 'Użytki gruntowe';
    static SOURCE_ID = 'src-land-use';
    static LAYER_IDS = ['lyr-land-use-fill', 'lyr-land-use-line'];

    getFillColorExpression() {
        return LAND_USE_COLOR_EXPRESSION;
    }

    getFillOpacity() {
        return 0.38;
    }

    getLineColor() {
        return 'rgba(82,69,54,0.34)';
    }

    getAttribution() {
        return landUseAttribution();
    }
}
